import SubUserAPIs from '@/API/subusers-api'

export default {
  namespaced: true,
  state: {
    fetched: false,
    showTour: false,
    totalSubUsers: 0,
    managers: [],
  },
  getters: {
    isManagersFetched: (state: any) => state.fetched,
    managers: (state: any) => state.managers,
    showTour: (state: any) => state.showTour,
    branchManagers: (state: any, getters: any, rootState: any, rootGetters: any) => state.managers.filter((manager: any) => manager.branches?.every((branch: any) => branch.id !== rootGetters['branches/currentBranchId'])),
    totalSubUsers: (state: any) => state.totalSubUsers,
  },
  mutations: {
    SET_MANAGERS(state: any, payload: any) {
      state.fetched = true
      state.managers = payload
    },
    SET_SHOW_TOUR(state: any, payload = true) {
      state.showTour = payload
    },
    SET_TOTAL_USERS(state: any, total: number) {
      state.totalSubUsers = total
    },
  },
  actions: {
    async FETCH_MANAGERS(context: any) {
      const managers = await SubUserAPIs.getManagers()
      context.commit('SET_MANAGERS', managers.managers)
      return managers.managers
    },
  },
}
